module.exports = __webpack_public_path__ + "img/bluesky3100_25.58ea96ff.jpg";